<template>
	<input v-model.lazy="path" :disabled="disabled"/>
</template>

<script>
import { mdbInput } from '@/components/mdbvue'

export default {
	name: 'PathInput',
	components: { mdbInput },
	props: {
		disabled: {
			type: Boolean,
			default: false
		},
		value: {
			type: String,
			default: 'tx'
		}
	},
	computed: {
		path: {
			get () { return (this.value === 'tx' || !this.value) ? '' : this.value.replace(/^tx\./, '') },
			set (value) { this.$emit('change', value === '' ? 'tx' : 'tx.' + value) }
		}
	}
}
</script>

<style scoped>

</style>
